"use client";
import {
  modal
} from "./chunk-GDOYJLDV.mjs";
import {
  mapPropsVariants
} from "./chunk-TKNQSGPN.mjs";
import {
  useModalContext
} from "./chunk-CNJJEWLJ.mjs";

// src/use-modal-header.ts
import { useDOMRef } from "@kirvanobr/react-utils";
import { clsx } from "@kirvanobr/shared-utils";
import { mergeProps, mergeRefs } from "@react-aria/utils";
import { useCallback } from "react";
function useModalHeader(originalProps) {
  const { slots, classNames, headerId, setHeaderMounted } = useModalContext();
  const [props, variantProps] = mapPropsVariants(originalProps, modal.variantKeys);
  const { ref, as, className, icon, description, children, ...otherProps } = props;
  const domRef = useDOMRef(ref);
  const Component = as || "header";
  const baseStyles = clsx(slots == null ? void 0 : slots.header, className);
  const getHeaderProps = useCallback(
    (props2 = {}) => ({
      className: slots.header({ class: clsx(baseStyles) }),
      id: headerId,
      ref: mergeRefs(domRef, props2.ref),
      ...mergeProps(otherProps, props2)
    }),
    [slots, className]
  );
  const getHeaderIconProps = useCallback(
    (props2 = {}) => ({
      className: slots.headerIcon({ class: clsx(classNames == null ? void 0 : classNames.headerIcon) }),
      ...props2
    }),
    [slots, className]
  );
  const getHeaderTitleProps = useCallback(
    (props2 = {}) => ({
      className: slots.headerTitle({ class: clsx(classNames == null ? void 0 : classNames.headerTitle) }),
      ...props2
    }),
    [slots, className]
  );
  const getHeaderDescriptionProps = useCallback(
    (props2 = {}) => ({
      className: slots.headerDescription({ class: clsx(classNames == null ? void 0 : classNames.headerDescription) }),
      ...props2
    }),
    [slots, className]
  );
  return {
    Component,
    icon,
    description,
    children,
    setHeaderMounted,
    getHeaderProps,
    getHeaderIconProps,
    getHeaderTitleProps,
    getHeaderDescriptionProps
  };
}

export {
  useModalHeader
};
